export default __webpack_public_path__ + "static/wtu_1-3aad5fa67f170dfbfaec53ce05a61af4.jpg";